import React from 'react';
import { Box, FakeLinkComponent } from '@rsos/components/capstone/base';
import { Description } from './JurisdictionNoShapeFiles.styles';

const JurisdictionNoShapeFiles = ({ handleView }) => {
  return (
    <Box align="center">
      <Description>
        Your active coverage can be viewed{' '}
        <FakeLinkComponent
          type="primary"
          withPadding={false}
          onClick={handleView}
          inline
        >
          here
        </FakeLinkComponent>
        . This coverage location will be updated once your jurisdictional
        boundary is verified.
      </Description>
    </Box>
  );
};

export default JurisdictionNoShapeFiles;
